import { render, staticRenderFns } from "./IbxSavingMessage.vue?vue&type=template&id=9ffbe200"
import script from "./IbxSavingMessage.vue?vue&type=script&lang=js"
export * from "./IbxSavingMessage.vue?vue&type=script&lang=js"
import style0 from "./IbxSavingMessage.vue?vue&type=style&index=0&id=9ffbe200&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports